import React from 'react';
import House from '../images/house.svg';
import ArchPl from '../images/arch.svg';
import InteriorDn from '../images/interior.svg';

function ServicesPage() {
    return (
        <div className="service-cont" id="services" style={{fontFamily: 'Roboto',fontWeight: '400'}}> 
                <div className="PageIntroBanner_header"><div className="row p-lg-5 proj-head-service" style={{marginRight:"0px"}}>
              <div className="col-lg-10 mx-auto text-center"><h3 style={{ marginTop: "25px",color : '#002856'}}>What we do.</h3></div></div>
          </div>
           
          <div className="row justify-content-center " style={{marginRight : "0px",marginLeft : "80px",backgroundColor: "#f7f7f7"}}>
              <div className="col-md-auto col-lg-3 " >
                <img className="img-responsive" width="200px" height="200px" src={ArchPl} alt="" />
                <h4 style={{marginTop : "25px",color:"#002856"}}>Architectural Plans</h4>
                <p style={{ width: "75%",marginLeft :"-25px" ,textAlign: "center",color:"#002856"}}>We will work with you to make small or large changes so you get the house of your dreams, You can purchase a cost to build report for any plan</p>
              </div>
              <div className="col-md-auto col-lg-3">
                <img className="img-responsive"  width="200px" height="200px" src={InteriorDn} alt="" />
                <h4 style={{marginTop : "25px",color:"#002856"}}>Interior Makeover</h4>
                <p style={{ width: "75%",marginLeft :"-25px",textAlign: "center" ,color:"#002856"}}>Whether you need flooring done, a basement developed, or a kitchen and bathroom renovated, our commitment to superior craftsmanship extends to interior renovations.</p>
              </div>
              <div className="col-md-auto col-lg-3 ">
                <img className="img-responsive"  width="200px" height="200px" src={House} alt="" />
                <h4 style={{marginTop : "25px",color:"#002856"}}>Quick Move-In Villas</h4>
                <p style={{ width: "75%",marginLeft :"-25px" ,textAlign: "center",color:"#002856"}} > Quick move-ins come with designer-selected features, you can often still personalize them to your needs, so that move-in ready also feels live-in ready.</p>
              </div>
          </div>
          <div className="service-foot"></div>
        </div>
    );

}

export default ServicesPage;